"use client";

import { ArrowRight, Loader } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const contactChannels = [{
  label: "INFORMAZIONI",
  email: "segreteria.aera@hotmail.com",
  description: "Consulenza su sistemi di estrazione e componenti."
}];
function ContactForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-10 bg-accent/10 border border-primary/30">
        <p className="font-mono text-xs uppercase tracking-widest text-primary mb-4">
          — RICHIESTA ACQUISITA
        </p>
        <p className="font-default text-2xl text-foreground mb-8">
          {successMessage}
        </p>
        <Button onClick={resetForm} variant="outline" className="font-mono text-xs uppercase tracking-widest bg-[#0099FF] text-[#0099FF] border-[#0099FF] hover:bg-[#0099FF]/90 hover:text-white">
          Invia nuova richiesta
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-10">
      <FormField control={control} name="name" render={({
      field
    }) => <FormItem className="gap-3">
            <FormLabel className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
              NOME E COGNOME / RAGIONE SOCIALE (Richiesta Tecnica)
            </FormLabel>
            <FormControl>
              <Input placeholder="Mario Rossi" {...field} className="bg-transparent border-0 border-b border-muted px-0 h-12 text-lg font-default focus-visible:ring-0 focus-visible:border-primary" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="email" render={({
      field
    }) => <FormItem className="gap-3">
            <FormLabel className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
              EMAIL AZIENDALE (Contatto Tecnico)
            </FormLabel>
            <FormControl>
              <Input type="email" placeholder="info@azienda.it" {...field} className="bg-transparent border-0 border-b border-muted px-0 h-12 text-lg font-default focus-visible:ring-0 focus-visible:border-primary" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="phone" render={({
      field
    }) => <FormItem className="gap-3">
            <FormLabel className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
              TELEFONO (Contatto Tecnico)
            </FormLabel>
            <FormControl>
              <Input type="tel" placeholder="+39 000 000 0000" {...field} className="bg-transparent border-0 border-b border-muted px-0 h-12 text-lg font-default focus-visible:ring-0 focus-visible:border-primary" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="subject" render={({
      field
    }) => <FormItem className="gap-3">
            <FormLabel className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
              TIPO DI IMPIANTO (Specializzazione Tecnica)
            </FormLabel>
            <FormControl>
              <Select onValueChange={field.onChange} value={field.value || ""}>
                <SelectTrigger className="w-full bg-transparent border-0 border-b border-muted px-0 h-12 text-lg font-default focus-visible:ring-0 focus-visible:border-primary data-[placeholder]:text-muted-foreground">
                  <SelectValue placeholder="Seleziona tipologia" />
                </SelectTrigger>
                <SelectContent className="bg-card border-border">
                  <SelectItem value="HVAC" className="font-mono text-xs uppercase tracking-wider">
                    Condotti HVAC
                  </SelectItem>
                  <SelectItem value="Cappe" className="font-mono text-xs uppercase tracking-wider">
                    Cappe Professionali
                  </SelectItem>
                  <SelectItem value="Aspirazione" className="font-mono text-xs uppercase tracking-wider">
                    Sistemi di Aspirazione
                  </SelectItem>
                  <SelectItem value="Altro" className="font-mono text-xs uppercase tracking-wider">
                    Altro
                  </SelectItem>
                </SelectContent>
              </Select>
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="message" render={({
      field
    }) => <FormItem className="gap-3">
            <FormLabel className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
              DESCRIZIONE ESIGENZA (Dettagli Tecnici)
            </FormLabel>
            <FormControl>
              <Textarea placeholder="Descrivi brevemente la necessità tecnica..." rows={4} {...field} className="bg-transparent border-0 border-b border-muted px-0 py-2 text-lg font-default focus-visible:ring-0 focus-visible:border-primary resize-none min-h-32" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 bg-destructive/10 border border-destructive/30">
          <p className="text-destructive font-mono text-xs uppercase tracking-wider">
            {submitError}
          </p>
        </div>}

      <div className="flex flex-col gap-6 items-start md:items-end pt-4">
        <Button type="submit" disabled={isSubmitting} className="group bg-[#0099FF] text-[#0099FF] hover:bg-[#0099FF]/90 font-mono text-xs uppercase tracking-[0.2em] px-8 h-14">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-4" />
              INVIO...
            </> : <>
              RICHIEDI SOPRALLUOGO
              <ArrowRight className="ml-2 size-4 transition-transform duration-300 group-hover:translate-x-1.5" />
            </>}
        </Button>
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
          RISPOSTA TECNICA ENTRO 24/48 ORE.
        </p>
      </div>
    </Form>;
}
export default function TechnicalInspection() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="3148" id="richiedi-intervento-specialistico" className="bg-background text-foreground py-32 md:py-48 px-6 md:px-12 lg:px-20 relative overflow-hidden">
      <div aria-hidden="true" className="absolute -top-40 -right-40 w-[600px] h-[600px] bg-primary/5 blur-3xl pointer-events-none" />
      <div aria-hidden="true" className="absolute -bottom-40 -left-40 w-[500px] h-[500px] bg-primary/5 blur-3xl pointer-events-none" />

      <div className="relative max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-12">
        <div ref={leftRef} className={`lg:col-span-5 flex flex-col transition-all duration-1000 ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-primary mb-10">
            — SERVIZIO PROFESSIONALE: SOPRALLUOGO TECNICO
          </p>

          <h2 className="font-default font-medium leading-[1.1] tracking-tighter text-[#00153D] mb-10" style={{
          fontSize: "clamp(2.5rem, 6vw, 4.5rem)"
        }}>
            CORE SERVICE: <br />
            ANALISI IMPIANTISTICA /
          </h2>

          <p className="font-default text-xl md:text-2xl text-muted-foreground leading-relaxed mb-16 max-w-md">
            Richiedi una valutazione specialistica per la riqualificazione igienico-funzionale dei tuoi impianti aeraulici.
          </p>

          <div className="flex flex-col mb-16">
            {contactChannels.map((channel, i) => <div key={channel.label} data-index={i} className="flex flex-col py-6 border-t border-border last:border-b group gap-2">
                <div className="flex items-center justify-between">
                  <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#0099FF] group-hover:text-primary transition-colors duration-300">
                    {channel.label}
                  </span>
                  <Link to={`mailto:${channel.email}`} className="font-default text-base md:text-lg text-foreground hover:text-primary transition-colors duration-300">
                    {channel.email}
                  </Link>
                </div>
                <p className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground/70">
                  {channel.description}
                </p>
              </div>)}
          </div>

          <div className="flex flex-col gap-3">
            <div className="flex items-center gap-3">
              <span className="size-2 bg-primary inline-block" />
              <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground">
                SEDE OPERATIVA
              </p>
            </div>
            <p className="font-mono text-xs uppercase tracking-[0.15em] text-foreground leading-relaxed">
              Via della Zarga 61
              <br />
              38015 Lavis TN
            </p>
          </div>
        </div>

        <div ref={rightRef} className={`lg:col-span-7 transition-all duration-1000 delay-200 ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <FormProvider formKey="intervention_form_technical_inspection" formId="intervention_form_technical_inspection" sectionName="richiedi-intervento-specialistico" defaultValues={{
          name: "",
          email: "",
          phone: "",
          subject: "",
          message: ""
        }} validationRules={{
          name: {
            required: true,
            minLength: 2,
            maxLength: 100
          },
          email: {
            required: true,
            pattern: "email"
          },
          phone: {
            required: false,
            pattern: "phone"
          },
          subject: {
            required: false
          },
          message: {
            required: true,
            minLength: 10
          }
        }} submitText="Invia Richiesta" successMessage="Richiesta ricevuta. Il nostro ufficio tecnico ti contatterà per definire i dettagli del sopralluogo." errorMessage="Si è verificato un errore. Riprova o contattaci telefonicamente." className="bg-card border border-border p-8 md:p-12 lg:p-20">
            <ContactForm />
          </FormProvider>
        </div>
      </div>
    </section>;
}